module.exports = {
  "country": "NL",
  "artist": "Duncan Lawrence",
  "song": "Arcarde",
  "year": "2019",
  "place": "1",
  "spotify": "1Xi84slp6FryDSCbzq4UCD"
};